import aboutReducer from "../about/state/reducer";
import alertsRecentReducer from "../alertsRecent/state/reducer";
import ipConfigReducer from "../ipConfig/state/reducer";
import ipConfigOnRebootReducer from "../ipConfigOnReboot/state/reducer";
import AjaxReducer from "../../ajax/state/reducer";
import UnixReducer from "../unix/state/reducer";
import RtcReducer from "../rtc/state/reducer";
import CommonState from "./";
import { combineReducers } from "redux";

const Reducer = combineReducers<CommonState>({
  io: AjaxReducer,
  about: aboutReducer,
  ipConfig: ipConfigReducer,
  ipConfigOnReboot: ipConfigOnRebootReducer,
  alertsRecent: alertsRecentReducer,
  unix: UnixReducer,
  rtc: RtcReducer
});

export default Reducer;
